export const VaultStrategy = ({ strategy }: { strategy: string }) => {
	return (
		<div className="flex flex-col gap-4">
			<span className="typo-t3 text-text-default">Strategy</span>
			<span className="typo-b4 text-text-secondary">{strategy}</span>
		</div>
	);
};
